import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import Pdf from "../service/Pdf";

i18next
  .use(initReactI18next)
  .use(Backend)
  .init({
    lng: 'i18n',
    fallbackLng: 'i18n',

    backend: {
      loadPath: `./locales/{{lng}}/{{ns}}.json`,
    },

    interpolation: {
      escapeValue: false // react already protects from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },

    react: {
      useSuspense: false
    }
  });

// Fetch translation file
fetch('./locales/i18n/translation.json').then((response) => {
  response.json().then((json) => {
    window.translation_json = json;

    // Preload font for PDF
    const pdf = new Pdf();
    pdf.loadAllFonts(true);
  });
});

// Request from parent page the i18n to be used.
if (window.location !== window.parent.location) {
  window.parent.postMessage({
    'name': 'i18n'
  }, "*");
}

// Set the i18n lang code to use from parent.
window['i18n'] = function (locale) {
  window.locale = locale;
};

// Set the i18n lang code to use from parent.
window['i18nJson'] = function (locale, json) {
  window.locale = locale;

  i18next.addResourceBundle(locale.lang, 'translation', json);

  i18next.loadLanguages([locale.lang]).then(() => {
    i18next.changeLanguage(locale.lang);
  });

  window['pdf'] = {
    phone: json['phone'],
    smart_collaboration: json['smart_collaboration'],
    moto_solutions: json['moto_solutions'],
    services_p2: json['services_p2'],
    accessories: json['accessories'],
    devices: json['devices'],
    software: json['software'],
  }
};
